/* eslint-disable no-unreachable */
import React, { lazy, Suspense } from 'react';
import { Tooltip, Input, Switch, Row, Col, Select, Spin, Modal, Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faCreditCard, faCaretDown, faCheck, faTimes, faRetweet } from '@fortawesome/free-solid-svg-icons';
import { addInitialDataApi, validateEmail, validateMobile, payInitialsFeesApi, getUploadsApi, paymentStatusApi } from './utils/ApiUtils';
import firebase from './utils/firebase';
import { COLORS, STRINGS } from './utils/Constants';
const StripePage = lazy(() => import("./Stripe.js"));

const { Option } = Select;

let yourName = "Your name as it is in any official ID Card."
let legalEntityName = "The full legal name of the company that owns the movie. You will be asked to provide any matching documentation for additional verification."
let legalEntityCountry = "The country where your legal entity is based. This will determine the primary currency of your tickets. This is also where you have a bank account where Hit.Movie will transfer your share of ticket revenue."
let mobile = "The mobile number along with the country code where we can reach you ANYTIME."
let email = "Your business email where we can send all official communication."
let movieName = "This is the Movie name end users see. You can edit this later.";
const checkText = "I agree the above details cannot be changed once submitted.";

let inputStyle = { width: '75%', color: COLORS.blue3a4a5a, fontSize: 14, fontFamily: 'OpenSans-Bold' };
let inputStyleDisabled = { width: '75%', color: 'rgba(0, 0, 0, 0.25)', fontSize: 14, fontFamily: 'OpenSans-Bold' };
let payButton = true, paymentStatusValue = 0, billingDetails = '', userId = 0;

export default class InitialDataForm extends React.Component {
  state = {
    name: '', mobile: '', email: '', entity: '', country: null, movieName: '', redIndex: 0, stripeObj: '',
    agreeSwitch: false, checkSwitch: false, loaderFees: false, modalPayment: 0, updateFeesResponse: [],
  };
  componentDidMount() {
    let sessionValue = localStorage.getItem('localStorageSession') || '';
    console.log('sessionValue='+sessionValue);
    if(sessionValue) {
      this.setState({ sessionValue: sessionValue });
    }
    let windowUrl = window.location.href;
    if(windowUrl.includes('paymentstatus')) {
      this.setState({ index: '1', loaderFees: true });
      this.paymentStatus(sessionValue);
    }
    console.log('latest did mount');
    let userObj = localStorage.getItem('userObj');
    userObj = JSON.parse(userObj);
    userId = userObj.id;
  }
  paymentStatus = (sessionValue) => {
      paymentStatusApi(sessionValue)
      .then(response => {
        console.log('paymentStatusApi data='+JSON.stringify(response));
        if(response.ok) {
          let resObj = response.info;
          this.setState({ loaderFees: false });
          if(resObj.paymentstatus==='Success') {
            this.setState({ modalPayment: 1 });
          }
          else if(resObj.paymentstatus==='Failed') {
            this.setState({ modalPayment: 2 });
          } else {
            if(paymentStatusValue<5) {
              paymentStatusValue++;
              setTimeout(
                () => { this.paymentStatus(sessionValue); }, 
                3000
              );
            }
          }
        } else {
          console.log('paymentStatusApi fetchig failed!');
          this.setState({ loaderFees: false });
        }
      })
      .catch((error) => {
        console.log('Error loading paymentStatusApi='+JSON.stringify(error));
        this.setState({ loaderFees: false });
      });
  }
  payButtonClick = () => {
    let sessionValue = this.state.sessionValue;
    if(!payButton) {
      return;
    }
    console.log('sessionValue='+sessionValue);
    let fees = 350000;
    let username = this.state.name;
    let mobile = this.state.mobile;
    let email = this.state.email;
    let entity = this.state.entity;
    let country = this.state.country;
    let movieName = this.state.movieName;
    if((!this.state.checkSwitch)||(!this.state.agreeSwitch)) {
      return;
    }
    this.setState({ loaderFees: true });
    payButton = false;
    if(!mobile.includes('+')) {
      mobile = '+'+mobile;
    }
    console.log('all set='+username+' mobile='+mobile+' email='+email+' country='+country+' entity='+entity);
    addInitialDataApi(sessionValue, fees, username, mobile, email, entity, country, movieName)
    .then(response => {
      console.log('Add initial data='+JSON.stringify(response));
      if(response.ok) {
        if(response.info&&response.info.uploadID) {
          this.props.setUploadId(response.info.uploadID);
          this.payButton2(sessionValue, response.info.initialFees.initialFees, response.info.uploadID, response.info.currency, mobile, email);
        } else {
          alert("Couldn't add Business details. Please try again.");
          this.setState({ loaderFees: false });
          payButton = true;
        }
      } else {
        console.log('Add Initial Data failed!');
        this.setState({ loaderFees: false });
        let message = response.info;
        if(message.includes('mobile')||message.includes('phone')) {
          this.setState({ redIndex: 5 });
        }
        else if(message.includes('email')) {
          this.setState({ redIndex: 6 });
        } else {
          alert(message);
        }
        payButton = true;
      }
    })
    .catch((error) => {
      console.log('Error Adding Initial data='+JSON.stringify(error));
      payButton = true;
    });
  }
  payButton2 = (sessionValue, listingFees, uploadId, currency, mobile, email) => {
    payInitialsFeesApi(sessionValue, listingFees, uploadId)
    .then(response => {
      console.log('pay initial fees='+JSON.stringify(response));
      if(response.ok) {
        console.log('init fees paid');
        let res = response.info;
        if(res.clientSecret) {
          console.log('payMovieStripeApi success='+JSON.stringify(res));
          let fees = '4999', currency = 'USD';
          let movieCountry = 'United States';
          let feesObj = this.props.listingFees;
          if(feesObj&&feesObj[0]) {
            fees = feesObj[0].initialFees;
            currency = feesObj[0].currency;
            movieCountry = feesObj[0].countryname;
            if((this.state.country)&&(feesObj[0].countryname!==this.state.country)&&(feesObj[0].countryname==='India')) {
              fees = feesObj[1].initialFees;
              currency = feesObj[1].currency;
              movieCountry = 'United States';
            }
          }
          let showPrice = { currency: currency, price: fees, movieCountry: movieCountry };
          let stripeObj = { movieName: 'Listing Fess', showPrice: showPrice, publishableKey: res.publishableKey, clientSecret: res.clientSecret, enableCaptcha: res.enableCaptcha };
          firebase.database().ref("users/").child(userId).child("/address/").once("value", snapshot => {
            if(snapshot&&snapshot.val()) {
              console.log('firebase Billing Details');
              billingDetails = snapshot.val();
            }
            this.setState({ stripeObj: stripeObj, loaderFees: false });
          });
        } else  {
          alert('Missing order id. Please try again.');
        }
      } else {
        console.log('Initial fees failed!');
        this.setState({ loaderFees: false });
        payButton = true;
      }
    })
    .catch((error) => {
      console.log('Error pay Initial fees='+JSON.stringify(error));
      this.setState({ loaderFees: false });
      payButton = true;
    });
  }
  updateFessPaid = () => {
    getUploadsApi(this.state.sessionValue)
      .then(response => {
        console.log('got uploads data='+(response));
        if(response.ok) {
          console.log('update fees success');
          this.setState({ modalPayment: 1, loaderFees: false, updateFeesResponse: response.info, name: '', 
          mobile: '', email: '', entity: '', country: null, movieName: '', redIndex: 0, agreeSwitch: false, checkSwitch: false });
        } else {
          console.log('Update fees failed!');
          this.setState({ modalPayment: 2, loaderFees: false });
        }
        payButton = true;
      })
      .catch((error) => {
        console.log('Error update  fees='+JSON.stringify(error));
        this.setState({ modalPayment: 2, loaderFees: false });
        payButton = true;
      });
  }
  goToMovies = (value) => {
    console.log('payment done. Value='+value);
    if(value) {
      this.setState({ modalPayment: 1, loaderFees: false, stripeObj: '', name: '', mobile: '', 
      email: '', entity: '', country: null, movieName: '', redIndex: 0, agreeSwitch: false, checkSwitch: false });
    } else {
      this.setState({ modalPayment: 2, loaderFees: false, stripeObj: '' });
    }
  }
  handleEntityChange = (e) => {
    let value = e.target.value;
    this.setState({ entity: value });
  }
  handleMovieName = (e) => {
    let value = e.target.value;
    this.setState({ movieName: value });
  }
  handleNameChange = (e) => {
    let value = e.target.value;
    this.setState({ name: value });
  }
  handleMobileChange = (e) => {
    let value = e.target.value;
    this.setState({ mobile: value });
  }
  handleEmailChange = (e) => {
    let value = e.target.value;
    this.setState({ email: value });
  }
  setCountry = (e) => {
    this.setState({ country: e });
    if(e) {

    } else {
      
    }
  }
  onCheckSwitch = (checked) => {
    if(!checked) {
      this.setState({ checkSwitch: false, agreeSwitch: false });
      return;
    }
    let username = this.state.name;
    let mobile = this.state.mobile;
    let email = this.state.email;
    let entity = this.state.entity;
    let country = this.state.country;
    let movie = this.state.movieName;

    let isEmail = validateEmail(email);
    let isMobile = validateMobile(mobile);
    console.log('isEmail='+JSON.stringify(isEmail));
    if(!movie) {
      this.setState({ redIndex: 1 });
      return;
    }
    if(!username) {
        this.setState({ redIndex: 2 });
        return;
    }
    if(!entity) {
        this.setState({ redIndex: 3 });
        return;
    }
    if(!country) {
      this.setState({ redIndex: 4 });
      return;
    }
    if(!isMobile) {
      this.setState({ redIndex: 5 });
      return;
    }
    if(mobile.length>14||mobile.length<10) {
        this.setState({ redIndex: 5 });
        return;
    }
    if(!isEmail) {
        this.setState({ redIndex: 6 });
        return;
    }
    this.setState({ redIndex: 0 });
    this.setState({ checkSwitch: true });
  }
  onAgreeSwitch = (checked) => {
    console.log('checkSwitch='+this.state.checkSwitch+' checked='+checked);
    if(!checked) {
      this.setState({ agreeSwitch: false });
    }
    else if(this.state.checkSwitch) {
      this.setState({ agreeSwitch: true });
    } 
  }
  setModal2Visible = () => {
    this.setState({ modalPayment: 0 });
  }
  sendToManage = () => {
    this.setState({ modalPayment: 0 });
    this.props.sendToManage();
  }
  render() {
    // console.log('sessionValue='+this.state.sessionValue);
    let legalCountries = this.props.legalCountries;
    // console.log('add movie props='+legalCountries);
    let detailsDisabled = this.state.checkSwitch;
    let enableMovie = false;
    let redIndex = this.state.redIndex;
    let warningColor = COLORS.red, textColor = COLORS.cccWhite;
    let disableForm = this.props.disableForm;
    let disablePage = disableForm||detailsDisabled;
    let appliedStyle = disablePage ? inputStyleDisabled : inputStyle;
    let fees = '4999', currency = 'USD';
    let feesObj = this.props.listingFees;
    if(feesObj&&feesObj[0]) {
      fees = feesObj[0].initialFees;
      currency = feesObj[0].currency;
      if((this.state.country)&&(feesObj[0].countryname!==this.state.country)&&(feesObj[0].countryname==='India')) {
        fees = feesObj[1].initialFees;
        currency = feesObj[1].currency;
      }
    }
    let modalPaymentCode = this.state.modalPayment;
    return (
      <div>
        <div style={{ border: '2px solid #1a2a3a' }}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.yellow, borderBottom: '2px solid #1a2a3a' }}>
                <div style={{ display: "flex", flex:1, justifyContent:'center', alignItems: "center", width: '100%', height:'100%' }}>
                  <FontAwesomeIcon color={COLORS.darkBlue} icon={faBuilding} style={{ fontSize: 24, margin: '12px' }} />
                  <h2 style={{ fontSize: 18, fontFamily: 'OpenSans-Bold', alignSelf:'center', textAlign:'center', color:'#1a2a3a', marginBottom: 0 }}>
                    Business Details
                  </h2>
                  <FontAwesomeIcon color={COLORS.darkBlue} icon={faBuilding} style={{ fontSize: 24, margin: '12px' }} />
                </div>
              </div>
              <Tooltip placement='left' trigger='hover' title={movieName}>
                <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                    <h3 className='formName' style={{ color: redIndex===1 ? warningColor : textColor }}>Movie Name</h3>
                  </div>
                  <Input className='bankInput' disabled={disablePage} placeholder="Movie Name" style={appliedStyle} value={this.state.movieName} 
                    onChange={(e) => { this.handleMovieName(e) }} />
                </div>
                </Tooltip>
              <Tooltip placement='left' trigger='hover' title={yourName}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: redIndex===2 ? warningColor : textColor }}>Your Name</h3>
                </div>
                <Input className='bankInput' disabled={disablePage} placeholder="Your Full Name" value={this.state.name} style={appliedStyle} 
                  onChange={(e) => { this.handleNameChange(e) }} />
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={legalEntityName}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: redIndex===3 ? warningColor : textColor }}>Legal Entity Name</h3>
                </div>
                <Input className='bankInput' disabled={disablePage} value={this.state.entity} placeholder="Full legal name of production company that owns the movie." 
                style={appliedStyle} onChange={(e) => { this.handleEntityChange(e) }} />
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={legalEntityCountry}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: redIndex===4 ? warningColor : textColor }}>Legal Entity Country</h3>
                </div>
                { disableForm
                ?
                <Input disabled={disablePage} value={this.state.country} placeholder="Country" style={appliedStyle} />
                :
                <Select className='customDropdown' disabled={disablePage} placeholder='Country' value={this.state.country}
                  style={{ flex:1, height: 54 }} onChange={(val)=>{ this.setCountry(val) }} 
                  suffixIcon={<FontAwesomeIcon color={COLORS.yellow} icon={faCaretDown} style={{ fontSize: 24 }} />}
                  showSearch={true} optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                    {
                    legalCountries.map((item, index) => {
                        return <Option key={index} value={item}>{item}</Option>
                    })
                    }
                </Select>
                }
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={mobile}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: redIndex===5 ? warningColor : textColor }}>Contact Mobile</h3>
                </div>
                <Input className='bankInput' disabled={disablePage} value={this.state.mobile} placeholder="Your Mobile Number with Country Code (Ex: +919123456780)" style={appliedStyle} onChange={(e) => { this.handleMobileChange(e) }} />
              </div>
              </Tooltip>
              <Tooltip placement='left' trigger='hover' title={email}>
              <div style={{ display: 'flex', flex:1, height: 54, backgroundColor: COLORS.blue2a3a4a, border: '1px solid #1a2a3a', borderTopWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", width: '25%', height:'100%' }}>
                  <h3 className='formName' style={{ color: redIndex===6 ? warningColor : textColor }}>Contact Email</h3>
                </div>
                <Input className='bankInput' disabled={disablePage} type='email' value={this.state.email} placeholder="Your Primary Email Address" style={appliedStyle} onChange={(e) => { this.handleEmailChange(e) }} />
              </div>
              </Tooltip>              
        </div>
        { disableForm
        ?
        <div />
        :
        <div style={{ width:'80%', marginLeft: '10%' }}>
          <div style={{ display: 'flex', justifyContent:'center', marginTop: 24 }}>
            <Switch className="greenSwitch" style={{ marginRight: 8, alignSelf:'center' }} 
              checked={this.state.checkSwitch} onChange={this.onCheckSwitch} />
            <h5 className="Agree" style={{ fontSize: 12, width: 400, textAlign:'left', alignSelf:'center', margin: 0, color: COLORS.redClose, fontFamily:'OpenSans-SemiBold' }}>
              {checkText}
            </h5>
          </div>
          <div style={{ display: 'flex', justifyContent:'center', marginTop: 12 }}>
            <Switch className="greenSwitch" style={{ marginRight: 8, alignSelf:'center' }} 
            checked={this.state.agreeSwitch} onChange={this.onAgreeSwitch} />
            <h5 className="Agree" style={{ width: 400, textAlign:'left', alignSelf:'center', margin: 0, color: COLORS.greybbb, fontFamily:'OpenSans-SemiBold' }}>
            I agree to all Hit.Movie <a href='https://docs.hit.movie/services-and-privacy-terms' target='_blank'>terms and conditions</a>. My movie does not contain hate speech and/or adult content. I agree that Hit.Movie reserves the final and binding right to accept or reject any content without assigning any reason whatsoever.
            </h5>
          </div>
          <div style={{ width: '100%', height: 60, marginTop: 24, display: 'flex', justifyContent:'center', }}>
            <div onClick={() => { this.payButtonClick() }} style={{ cursor:'pointer', width: 184, height: 58, background: COLORS.eeeWhite, borderRadius: 5 }}>
              <Row style={{ width: 180, height: 54, background: enableMovie ? COLORS.purple : (this.state.agreeSwitch ? COLORS.lightgreen : COLORS.greya3), borderRadius: 3, margin: 2 }}>
                <Col style={{ display: 'flex', justifyContent:'center', alignItems:'center' }} span={8}>
                  <FontAwesomeIcon color={COLORS.blue2a3a4a} icon={faCreditCard} style={{ fontSize: 24 }} />
                </Col>
                <div style={{ display: 'flex', alignItems:'center', width: 120, height: 56 }}>
                    <div className='col' style={{  }}>
                      <p style={{ color: COLORS.blue2a3a4a, fontSize: 18, marginBottom: 4, textAlign:'left', fontFamily: 'OpenSans-Bold' }}>{currency} {fees}</p>
                      <p style={{ color: COLORS.blue2a3a4a, textAlign:'left', lineHeight: 0, fontFamily: 'OpenSans-Bold' }}>Listing fees</p>
                    </div>
                  </div>
              </Row>
            </div>
          </div>
        </div>
        }
        { this.state.loaderFees &&
          <div style={{ position: 'fixed', backgroundColor: 'rgba(10, 26, 42, 0.6)', top: 0, bottom: 0, left: 200, right: 0, zIndex: 9999 }}>
            <Spin size='large' style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} />
          </div>
        }
        <Modal className="stripeModal" width={320} centered={true} visible={this.state.stripeObj} maskClosable={false}
        onCancel={() => { payButton = true; this.setState({ stripeObj: '' }); }} destroyOnClose={true}
        closeIcon={<FontAwesomeIcon className='modalCloseIcon' icon={faTimes} style={{ fontSize: 36 }} />}
        bodyStyle={{ padding: 0 }} 
        footer={<div style={{ display: 'flex', justifyContent: 'center' }}>
          <img className="custom2" src={require('./images/stripePowered.png')} alt='Powered by Stripe' 
          style={{ width: 125, height: 28, marginTop: 10 }} />
        </div>}>
          <Suspense fallback={<h1>Loading…</h1>}>
            <StripePage stripeObj={this.state.stripeObj} billingDetails={billingDetails} userId={userId} goToMovies={this.goToMovies} />
          </Suspense>
        </Modal>
        <Modal
          style={{ backgroundColor: COLORS.greenSuccess, marginTop: 100, paddingBottom: 0, borderRadius: 3 }}
          title={null}
          closable={true}
          closeIcon={<FontAwesomeIcon className='modalCloseIcon'icon={faTimes} />}
          footer={null}
          visible={modalPaymentCode===1}
          onOk={() => this.setModal2Visible(false)}
          onCancel={() => this.setModal2Visible(false)}
        >
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <FontAwesomeIcon color={COLORS.white} icon={faCheck} style={{ fontSize: 32 }} />
          </div>
          <p style={{ color: COLORS.white, textAlign:'center', fontFamily: 'OpenSans-Bold', marginTop: 12 }}>Payment Successful</p>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button onClick={() => { this.sendToManage() }} className='caption' 
            style={{ display: "flex", alignItems: "center", justifyContent:'center', width: 200, height: 40, backgroundColor: COLORS.white, borderRadius: 3, margin: 10, opacity: 1 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent:'center' }}>
                <h4 style={{ display: "flex", alignItems: "center", color: COLORS.greenSuccess, fontSize: 14, height:'100%', margin:0, fontFamily: 'OpenSans-Bold' }}>
                Go to Manage Movies
                </h4>
              </div>
            </Button> 
          </div>
          <p style={{ color: COLORS.white, textAlign:'center', fontFamily: 'OpenSans-Bold', marginTop: 12 }}>Billing Support: billing@hit.movie</p>
        </Modal>
        <Modal
          style={{ backgroundColor: COLORS.redFail, marginTop: 100, paddingBottom: 0, borderRadius: 3 }}
          title={null}
          closable={true}
          closeIcon={<FontAwesomeIcon className='modalCloseIcon'icon={faTimes} />}
          footer={null}
          visible={modalPaymentCode===2}
          onOk={() => this.setModal2Visible(false)}
          onCancel={() => this.setModal2Visible(false)}
        >
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <FontAwesomeIcon color={COLORS.white} icon={faRetweet} style={{ fontSize: 32 }} />
          </div>
          <p style={{ color: COLORS.white, textAlign:'center', fontFamily: 'OpenSans-Bold', marginTop: 12 }}>Payment Failed</p>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button onClick={() => { this.setModal2Visible(false) }} className='caption' 
            style={{ display: "flex", alignItems: "center", justifyContent:'center', width: 200, height: 40, backgroundColor: COLORS.white, borderRadius: 3, margin: 10, opacity: 1 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent:'center' }}>
                <h4 style={{ display: "flex", alignItems: "center", color: COLORS.redFail, fontSize: 14, height:'100%', margin:0, fontFamily: 'OpenSans-Bold' }}>
                  Retry
                </h4>
              </div>
            </Button> 
          </div>
          <p style={{ color: COLORS.white, textAlign:'center', fontFamily: 'OpenSans-Bold', marginTop: 12 }}>Billing Support: billing@hit.movie</p>
        </Modal>
      </div>
    );
  }
}
